import React from 'react';
import { connect } from 'react-redux';

import { Panel, PanelTop } from 'components/Panel';
import { Table, Td } from 'components/Table';
import { dateRows } from 'components/util';

const FixturesX = ({ fixtures }) => (
    <Panel border>
        <PanelTop>
            <h2>Fixtures</h2>
        </PanelTop>
        <div>
            <Table compact topborder>
                <tbody>
                    {dateRows(fixtures, 6, (fixture, longDate, shortestDate, rowClassName) => (
                        <FixturesRow key={fixture.mid} fixture={fixture} shortestDate={shortestDate} rowClassName={rowClassName} />
                    ))}
                </tbody>
            </Table>
        </div>
    </Panel>
);

const Fixtures = connect(state => ({
    fixtures: state.data.fixtures
}))(FixturesX);

export default Fixtures;

const FixturesRow = ({ fixture, rowClassName, shortestDate }) => {
    let opposition = fixture.opposition;
    if (fixture.url) {
        opposition = (
            <a href={fixture.url} target="_new">
                {opposition}
            </a>
        );
    }
    return (
        <tr className={rowClassName}>
            <Td>{shortestDate}</Td>
            <Td>
                <a href={`/teams/${fixture.link_date}`}>{fixture.team}</a> v
            </Td>
            <Td left>{opposition}</Td>
            <Td>{fixture.time}</Td>
            <Td left>{fixture.location}</Td>
        </tr>
    );
};



// WEBPACK FOOTER //
// ./src/views/home/Fixtures.jsx